import React, { useState } from 'react';
import Styled from 'styled-components';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import CircularProgress from '@mui/material/CircularProgress';
import Applet, { AppletContainer } from '../../Components/Applet';
import WelcomeToDavie from '../../Components/WelcomeToDavie';
import GridContainer from '../../Components/Grid';
import { downloadFile } from '../../Hooks/useUpload';
import { useAuth } from '../../Contexts/AuthContext';
import usePost from '../../Hooks/usePost';
import { StyledButton } from '../../Components/Generics.styled';

const LoginContainer = Styled.div`
margin-top: 100px;
width: 100%;
margin-bottom: 100px;
`;

const FormName = Styled.div`
text-align: left;
letter-spacing: 0.77px;
color: #000000DE;
opacity: 1;
padding-left: 15px;
padding-top: 11px;
font-size: 23px;
`;

const LoginTextFieldContainer = Styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 25px;
  margin-left: 15px;
  margin-right: 15px;
`;

const LoginButton = Styled(Button)`
background: #2e69fe 0% 0% no-repeat padding-box !important;
box-shadow: 0px 3px 3px #00000061;
border-radius: 4px;
opacity: 1;
width: 100px;
left: 220px;
    &.MuiButton-contained.Mui-disabled {
    color: #fafbf7;
  }
  :disabled {
    background: #9b9b9d 0% 0% no-repeat padding-box !important;
  }
`;

const ForgotPasswordLink = Styled(Link)`
letter-spacing: 0px;
color: #3F51B5;
opacity: 1;
text-align: right;
margin-top: 10px;
`;

const StyledCheckbox = Styled.div`
.MuiTypography-body1 {   
  letter-spacing: 0px;
  color: #000000;
  opacity: 1;
}  

`;

const TermsAndConditionsBox = Styled(TextField)`
.MuiOutlinedInput-input {
    height: 380px;
    padding-right: 15px;
}
`;

const DownloadLinks = Styled.div`
    text-align: center;
    margin-top: 10px;
    height: 50px;
    color: #0000EE;
    opacity: 1;
    cursor: pointer;

    :hover{
      text-decoration: underline;
    }
`;

const Signup = () => {
    const [values, setValues] = useState({
        firstName: '',
        lastName: '',
        phone: '',
        email: '',
        password: '',
        confirmPassword: '',
        showPassword: false,
        showConfirmPassword: false,
        termsIsChecked: false,
    });

    const {
        firstName,
        lastName,
        phone,
        email,
        password,
        confirmPassword,
        showPassword,
        showConfirmPassword,
        termsIsChecked,
    } = {
        ...values,
    };

    const strongEmailRegex =
        // eslint-disable-next-line no-useless-escape
        /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    const phoneRegex =
        /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/i;

    const emailIsNotValidFormat = !email.match(strongEmailRegex);
    const phoneIsNotValidFormat = !phone.match(phoneRegex);

    const { post } = usePost('/signup');
    const { post: checkUserExistsPost } = usePost('/checkUserExists');

    const initialPostDataVals = {
        success: false,
        error: false,
        isLoading: false,
        message: [],
    };
    const [postData, setPostData] = useState({ ...initialPostDataVals });

    const { login } = useAuth();

    const handleMouseDownPassword = (e) => {
        e.preventDefault();
    };

    const handleOnChange = (value, e) => {
        setPostData({ ...initialPostDataVals });
        setValues({ ...values, [value]: e.target.value });
    };
    const handleConfirmPassword = (e) => {
        setValues({ ...values, confirmPassword: e.target.value });
    };

    function checkPassword(str) {
        const re = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[\s\S])[A-Za-z\d\s\S]{6,100}$/;
        return re.test(str);
    }
    const isDisabled =
        !firstName ||
        !lastName ||
        !phone ||
        phoneIsNotValidFormat ||
        !email ||
        emailIsNotValidFormat ||
        !password ||
        !confirmPassword ||
        !termsIsChecked ||
        !checkPassword(password) ||
        password !== confirmPassword;

    //expire token 1 year from today
    const todaysDate = new Date();
    const aYearFromNow = todaysDate.setFullYear(todaysDate.getFullYear() + 1);
    const aYearFromNowFormatted = new Date(aYearFromNow).toISOString().substring(0, 10);

    const handleSignup = async () => {
        try {
            setPostData({ ...postData, isLoading: true });

            const checkUserExistsResp = await checkUserExistsPost({ userName: email }, 'POST');

            if (!checkUserExistsResp.data.userExists) {
                // user does not exist, proceed with signup
                const signUpResp = await post(
                    {
                        userName: email,
                        password,
                        firstName,
                        lastName,
                        phoneNumber: phone,
                        isEnabled: true,
                        userExpiresOn: aYearFromNowFormatted,
                    },
                    'POST'
                );

                if (signUpResp.data.result === false) {
                    // create account error
                    const { errors } = signUpResp.data;
                    setPostData({ ...postData, error: true, isLoading: false, message: errors });
                } else {
                    // create successful, login User
                    const resp = await login(email, password);
                    if (resp.data.authenticated) {
                        setPostData({
                            ...postData,
                            isLoading: false,
                            success: true,
                            message: ['Sign in successful.'],
                        });
                    }
                }
            } else {
                // user Exists, send error
                setPostData({
                    ...postData,
                    isLoading: false,
                    success: false,
                    error: true,
                    message: ['User already exists.'],
                });
            }
        } catch (err) {
            setPostData({
                ...postData,
                error: true,
                isLoading: false,
                success: false,
                message: ['Something went wrong, Please Try again.'],
            });
        }
    };

    const handleCheckBox = () => {
        setValues({ ...values, termsIsChecked: !termsIsChecked });
    };

    return (
        <>
            <WelcomeToDavie />
            <LoginContainer>
                <AppletContainer>
                    <Applet height="1200px">
                        <FormName>Sign Up</FormName>
                        <LoginTextFieldContainer>
                            <TextField
                                error={!firstName}
                                helperText={!firstName ? 'First Name cannot be empty.' : ''}
                                id="firstName-signup"
                                label="First Name"
                                defaultValue={firstName}
                                onChange={(e) => handleOnChange('firstName', e)}
                                variant="outlined"
                                required
                            />
                            <br />
                            <TextField
                                error={!lastName}
                                helperText={!lastName ? 'Last Name cannot be empty.' : ''}
                                id="lastName-signup"
                                label="Last Name"
                                defaultValue={lastName}
                                onChange={(e) => handleOnChange('lastName', e)}
                                variant="outlined"
                                required
                            />
                            <br />
                            <TextField
                                id="phone-signup"
                                label="Phone Number"
                                defaultValue={phone}
                                onChange={(e) => handleOnChange('phone', e)}
                                variant="outlined"
                                required
                                error={phoneIsNotValidFormat}
                                helperText={
                                    phoneIsNotValidFormat
                                        ? 'Phone number must be in valid format. Example 222-222-2222.'
                                        : ''
                                }
                            />
                            <br />
                            <TextField
                                id="email-signup"
                                label="Email Address"
                                defaultValue={email}
                                onChange={(e) => handleOnChange('email', e)}
                                variant="outlined"
                                required
                                error={emailIsNotValidFormat}
                                helperText={
                                    emailIsNotValidFormat
                                        ? 'Email must be in valid format. Example test@test.com.'
                                        : ''
                                }
                            />
                            <br />
                            <TextField
                                id="password-signup"
                                label="Password"
                                type={showPassword ? 'text' : 'password'}
                                error={!checkPassword(password)}
                                helperText={
                                    !checkPassword(password)
                                        ? 'Password must be between 6 and 100 Characters, it must contain at least one number, one special character and both an uppercase and lowercase letter.'
                                        : ''
                                }
                                defaultValue={password}
                                required
                                onChange={(e) => handleOnChange('password', e)}
                                variant="outlined"
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <StyledButton
                                                aria-label="toggle password visibility"
                                                onClick={() =>
                                                    setValues({
                                                        ...values,
                                                        showPassword: !showPassword,
                                                    })
                                                }
                                                onMouseDown={(e) => handleMouseDownPassword(e)}
                                            >
                                                {showPassword ? <Visibility /> : <VisibilityOff />}
                                            </StyledButton>
                                        </InputAdornment>
                                    ),
                                }}
                            />
                            <br />
                            <TextField
                                error={password !== confirmPassword}
                                helperText={
                                    password !== confirmPassword ? 'Passwords do not match' : ''
                                }
                                id="confirmPassword-signup"
                                label="Retype Password"
                                type={showConfirmPassword ? 'text' : 'password'}
                                defaultValue={confirmPassword}
                                onChange={(e) => handleConfirmPassword(e)}
                                variant="outlined"
                                required
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <StyledButton
                                                aria-label="toggle password visibility"
                                                onClick={() =>
                                                    setValues({
                                                        ...values,
                                                        showConfirmPassword: !showConfirmPassword,
                                                    })
                                                }
                                                onMouseDown={(e) => handleMouseDownPassword(e)}
                                            >
                                                {showConfirmPassword ? (
                                                    <Visibility />
                                                ) : (
                                                    <VisibilityOff />
                                                )}
                                            </StyledButton>
                                        </InputAdornment>
                                    ),
                                }}
                            />
                            <br />
                            <TermsAndConditionsBox
                                id="cell-signup"
                                label="Terms and Conditions"
                                defaultValue="1 This Advertiser Agreement (the “Agreement”) by and between the advertiser registering on LifeWise Digital, Inc. Advertiser
                web portal (“Advertiser”) and LifeWise Digital Inc., (“LifeWise”) a Delaware Corporation with an address at 6 Canterbury Lane, Bluffton, SC 29910
                 (“LifeWise”). This Agreement covers the terms and conditions whereby the
                Advertiser may advertise on LifeWise’s digital marketing web site, app or other digital platforms (“LifeWise Publication”)
                including, but not limited to Coupanda®, NearBuyLife®, PerkPlusUSA®, SanMarinoPure.com® and PayMeToConnect® or
                on third-party digital publications accessed through LifeWise media buying service. The Advertiser and LIFEWISE
                individually may be referred to as a “Party” or collectively as the “Parties”. The Parties agree as follows:
                1. DEFINITIONS
                a) “Advertiser” means any person, firm or company who acting as Principal places a media purchase order (“Order”) with or
                through LifeWise.
                b) “Advertising Agency” means any person, firm, company or advertising specialist recognized as an Advertising Agency by
                LifeWise and who is acting as an agent for the Advertiser when placing an Order with LifeWise.
                c) “Advertising Content” means any advertising content or media intended for display on a LifeWise Publication or on a thirdparty publication using LifeWise software or services.
                d) “Agreement” means a legally binding agreement between the Parties consisting of a Campaign Placement Order and an
                acceptance thereof by LifeWise.
                e) “Click” means the action by the user of a mobile device or computer to use a mouse or other means to click on or open
                Advertising Content in order to interact with the additional information or link to an Internet-connected destination imbedded
                in the Advertising Content.
                f) “Display Period” means the period of display of an advertisement or the period over which the Advertising Agency or
                Principal has purchased the media.
                g) “Display Period Start Date” means the date from which the specified Advertising Content may be displayed.
                h) “Fee” or “Rate” means the consideration for the display of Advertising Content on the media platform specified and also
                for a user’s Click on the Advertising Content or Redemption of a Coupon.
                i) “Impression” means the display of Advertising Content by LifeWise on LifeWise Publication or other digital media platform.
                j) “Location” means the geographic locations at which LifeWise may display Advertising Content.
                k) “LifeWise” means LIFEWISE DIGITAL, INC. whose registered office is 24 Woodbine Avenue, Suite 205, Northport, NY
                11768 and any of its related parties or contracted owners of participating media outlets.
                l) “Media Type” means the type of Advertising Content to be displayed including display or video ads and images, SMS text
                messages, emails and other digital Advertising Content that the Parties agree to display through LifeWise.
                m) “Order” or “Campaign Placement Order” means an advertising purchase order submitted by the Principal to LifeWise for
                the display of Advertising Content whether such order is placed with LifeWise through its on-line advertiser portal or manually
                through a written document.
                n) “Payment Terms” means the terms specified on the Placement Order for which the Fee is to be paid by the Principal to
                LifeWise.
                o) “Parties” means LifeWise and Principal and Agent.
                p) “Principal” means any Advertiser or Advertising Agency and shall include their successors in title and agents who give an
                Order to LifeWise and as such is liable for payment of display of Advertising Content.
                q) “Production Specifications” means the information submitted to LifeWise in order to create display, video or other
                advertising content at the request of the Advertiser.
                r) “Terms and Conditions” means the terms and conditions set out in this document. This document is referenced on LifeWise
                Advertiser portal and is available for public view on www.LifeWiseDigital.com/Advertise.
                s) “User” means the individual or entity that has accessed LifeWise media platform or mobile application to view Advertising
                Content.
                2. APPLICATION OF THESE TERMS AND CONDITIONS
                a) The Principal shall be ultimately responsible for the payment of Fees and shall be deemed to have full authority in all
                matters connected with the placing of the order and the approval or amendment of Advertising Content. A media agency or
                specialist media buyer shall be regarded for all purposes as the Principal. For the avoidance of doubt, every order accepted
                by LifeWise will be for a specified Advertiser and any change to the Advertiser must be agreed in writing by LifeWise.
                b) The Terms and Conditions together with any additional terms set out in the Campaign Placement Order will be legally
                binding on LifeWise and the Principal in respect of each Order submitted by the Principal on the day submitted. Advertising 
                2
                Content or Campaign Placement Order changes may be accepted at the discretion of LifeWise until the date Advertising
                Content is to be display on LifeWise Publication or third-party media platform.
                c) Any Orders accepted shall only be used for displaying the Advertising Content supplied in relation to the Campaign
                Placement Order instructions.
                3. DISPLAY OBLIGATIONS
                a) LifeWise will (subject to Clause 2 above) unless otherwise agreed in writing, display Advertising Content up to the budget
                limit, or designated number of Impressions and or Clicks indicated on the Campaign Placement Order to internet connected
                mobile devices, computers, advertising-supported streaming TV channels that are accessed via LifeWise platform. LifeWise
                reserves the right to the display the Advertising Impressions indicated on the Campaign Placement Order, up to or beyond
                the number of Impressions indicated thereon at its discretion provided such display is within the start date and end date
                specified in the Campaign Placement Order and is within the budget limitations defined in the Campaign Placement Order.
                In the event that LIFEWISE Users qualified to receive an Impression are not sufficient to meet the number of Impressions
                indicated in the Placement Order, the duration of the advertising campaign indicated in the Campaign Placement Order may
                be extended and the Advertiser may modify or replace the Advertising Content.
                b) LIFEWISE may reject any Advertising Content that it deems inappropriate for LifeWise Publication or third-party media
                platform and will assist Advertiser in redesign and resubmission of Advertising Content to meet LifeWise standards and
                requirements or those of third-party media platforms.
                4. SUPPLY OF MATERIAL
                a) All Advertising Content (subject to any other terms in the Campaign Placement Order) is to be supplied to LifeWise digitally
                or at the place(s) and within the time specified by LifeWise. All Advertising Content shall be produced and supplied to LifeWise
                in accordance with the Production Requirements provided by LifeWise.
                b) In the event that the Parties agree that LifeWise will undertake production of Advertising Content, LifeWise agrees to
                provide content compliant to the Production Requirements, and if the Advertiser shall produce or have produced all
                Advertising Content then the Advertiser shall adhere to the Production Requirements and provide all detail necessary to
                allow such production to take place within the necessary timeframe.
                c) LifeWise shall be supplied with Advertising Content not lets than one business day in advance of the Display Period Start
                Date in accordance with the Production Requirements so as to enable LifeWise to present and maintain the display in good
                condition.
                d) Should the Principal fail to deliver Advertising Content in accordance with this Agreement prior to the Campaign Placement
                Order Display Period Start Date, LifeWise may modify the Display Period Start Date until such Advertising Content is
                received.
                e) In the event that the Placement Order instructions are not complete or not clear, or the Delivery of Advertising Content
                does not, in the opinion of LifeWise, meet the Production Requirements, the Campaign Placement Order may not be deemed
                acceptable by LifeWise.
                f) The Advertiser expressly permits LifeWise to use the Advertiser’s name and logo or an image of the Advertising Content
                on in LifeWise’s marketing materials.
                5. INVOICING AND CHARGES
                a) LifeWise may require a payment with the submission of a Campaign Placement Order in order to accept the Campaign
                Placement Order and to display the Advertising Content related thereto.
                b) Invoices will be issued to the Advertiser by LifeWise at the end of each calendar month during the Display Period for the
                monthly budget amount and any additional charges related to the display of Impressions or the number of Clicks that have
                occurred during the said calendar month.
                c) Payment of Fees is due in accordance with the Payment Terms. If Fees are not paid in accordance with the Payment
                Terms LifeWise may, without prejudice to any other remedy it may have and without prejudice to Principal’s obligation to pay
                the Fees, refuse to display any Advertising Content or withdraw currently displayed Advertising Content.
                d) Invoices shall be sent to the Principal for payment by the Principal unless otherwise expressly agreed between the Parties
                in writing. Where LifeWise has been notified by the Principal in writing that a third party has been appointed by the Principal,
                invoices will be sent to the Principal’s third-party and shall clearly identify the Principal for whom the third-party is acting.
                e) In the event of failure to comply with any of the provisions of this Clause 5 LifeWise reserves the right to require any other
                Order to be dealt with in accordance with revised payment terms.
                3
                f) In respect of any Fees not received by LifeWise in accordance with the Payment Terms the Principal will be liable to pay
                to LifeWise interest at a rate of three percent (3%) above the then published prime rate for Wells Fargo Bank N.A.
                g) In the event of unpaid account Advertiser’s account information may be shared with LifeWise’s appointed Debt Collection
                Agency or Attorneys.
                6. WARRANTIES, LIABILITY AND INDEMNITY
                a) The Principal warrants and undertakes that:
                i. all Advertising Content will comply with all statutory and legal requirements and regulations from time to time in force
                including any applicable state or federal law regarding the display of advertising;
                ii. they will be responsible for obtaining and paying for all necessary licenses and consents for the posting and/or displaying
                and/or reproduction of any Advertising Content or copyright material contained in or the appearance of any person in his
                Advertising Content; and
                iii. no Advertising Content will breach the copyright or other intellectual property rights or be defamatory of any third party.
                c) The Principal will indemnify and keep LifeWise indemnified against all actions, proceedings, costs, damages, expenses,
                penalties, claims, demands and liability (including legal fees) incurred and arising from any breach of the above warranties
                or in any manner whatsoever.
                d) LifeWise shall have the right to refuse to display or to continue to display any Advertising Content which does not or which
                in LifeWise’s opinion may not comply in all respects with the Principal’s warranties and undertakings detailed in Clause 6(a)
                above. In such event LifeWise shall not be liable to the Principal for any damage loss or expense whatsoever and in addition
                to any remedy and/or damages and/or loss that may be claimed by LifeWise against the Principal, the Fees corresponding
                to display of such Advertising Content will be due in full notwithstanding that the Advertising Content has not been displayed.
                e) LifeWise reserves the right not to display Advertising Content or to remove a display of Advertising Content at any time if
                in its absolute discretion, LifeWise believes the Principal and the Advertising Content is not in compliance with the warranties
                in Clause 6(a) above. In such event LifeWise shall not be liable to the Principal for any damage loss expense whatsoever.
                f) The performance of any Agreement is subject to suspension, variation or cancellation by LifeWise (in whole or in part)
                owing to Acts of God, strikes, lockouts, legal restrictions, power supply failures, or the loss of Internet or Cellular network
                availability which were included in the Agreement or for any other reason beyond LifeWise’s control. In the event of
                suspension, variation or cancellation for any of the foregoing reasons LifeWise shall be entitled to modify the Display Period
                designated in the Placement Order until the display of Advertising Content is again possible.
                g) LifeWise shall not be liable for loss of or damage to any Advertising Content supplied to LifeWise in the event of any form
                of any act of God or service interruption required to distribute Advertising Content.
                7. TERMINATION
                a) The Agreement is non-transferable and is subject to the following cancellation penalties of the value or a Campaign
                Placement Order:
                • 25% if 10 days or more before the designated Display Period Start Date.
                • 50% if within 24 hours of the designated Display Period Start Date.
                b) LifeWise may terminate the Agreement immediately with notice in writing to the Principal if:
                i. the Principal shall become bankrupt or make any assignment for the benefit of his creditors or shall become insolvent or if
                any petition for the winding or if any other step is taken for the purposes of the appointment of a receiver; or
                ii. the Principal ceases to operate its business;
                iii. if any monies to be paid by the Principal to LifeWise shall be in arrears for more than thirty (30) days; or
                iv. if there has been a breach by the Principal of any terms of the Agreement; or
                8. CONSEQUENCES OF TERMINATION
                a) Following termination of the Agreement the Principal will pay to LifeWise immediately all outstanding Fees (plus interest,
                in accordance with Clause 5(f), above).
                b) Any termination of the Agreement and payment of Fees due shall be without prejudice to any other right of action or
                remedy which LifeWise may have under the Agreement or at law.
                c) In the event of termination under Clause 7, LifeWise may continue to display any Advertising Content and may enter into
                any agreements with third parties as considered appropriate to secure payment for continuing such display.
                4
                d) In the event of a termination by LifeWise in accordance with Clause 12 LifeWise shall be entitled to be paid by the Principal
                the full rate for the Impressions and Clicks up to and until the time at which the display is discontinued together with any other
                Fees due and owing by the Principal to LifeWise but LifeWise shall not be liable to pay any damages losses or expenses to
                the Principal as a result or in respect of such suspension, variation or cancellation.
                9. VALIDITY
                If any provision of these Terms and Conditions or the Agreement is held by any court or other competent authority to be void
                or unenforceable in whole or part, the other provision of these Terms and Conditions and/or the Agreement and the remainder
                of the affected provisions shall continue to be valid.
                10. NOTICES
                a) All notices under this Agreement will be in writing.
                b) Notices shall be deemed to have been duly given:
                i. when delivered, if delivered by courier or other messenger (including registered mail) during normal business hours of the
                recipient; or
                ii. when sent, if transmitted by fax or e-mail; or
                iii. on the fifth business day following mailing, if mailed by national ordinary mail, postage pre-paid; or.
                11. ASSIGNMENT
                Neither LifeWise nor the Principal may assign, transfer, charge or part with all or any of its rights and/or obligations under
                the Agreement.
                12. REMOVAL FOR PURPOSES OF LIFEWISE’S UNDERTAKING
                If LifeWise at any time in its absolute discretion requires the display of Advertising Content to be pre-approved by any third
                party or interrupted or discontinued as a result of a claim, complaint or other similar issue, then LifeWise may discontinue
                the display of Advertising Content by notifying the Principal of such interruption and upon any such action of LifeWise and
                Advertiser may modify the Campaign Placement Order or Terminate the Campaign Placement Order either wholly or in part
                notwithstanding anything therein contained. In the event of such termination, LifeWise’s liability is limited as outlined in Clause
                8(d) above and the Principal shall be obligated to pay for the portion of the Campaign Placement Order Impressions and
                Clicks up to the date of such modification or termination.
                13. CONFLICT OF TERMS
                In the event of any conflict between the Terms and Conditions and a Campaign Placement Order, the provisions of the
                Campaign Placement Order shall prevail.
                14. JURISDICTION AND GOVERNING LAW
                These Terms and Conditions shall be governed by and construed in accordance with the laws of the state of New York and
                the Parties agree to the jurisdiction of the New York state courts and federal district courts in New York in relation to any
                conflict.
                15. AGENCY/PARTNERSHIP
                The Agreement shall not constitute or imply any partnership, joint venture, agency, fiduciary relationship or other relationship
                between the Parties other than the contractual relationship expressly provided for in this Agreement.
                16. MODIFICATION
                LifeWise reserves the right to revise these Terms and Conditions from time to time by notice to the Principal. LifeWise will
                post any revised Terms and Conditions on LifeWise website and the Principal should check this website upon notice of any
                such revisions. The Principal’s continued placement of an Order after such revision has been made will be deemed an
                acceptance by the Principal of the Terms and Conditions existing at the time.
                17. ENTIRE AGREEMENT
                The Agreement contains the whole agreement between the Parties relating to the subject matter hereof and supersedes any
                and all prior agreements, arrangements and understandings between the Parties relating to that subject matter. Accordingly,
                all prior agreements, whether or not agreed or offered and all conditions and warranties whether express or implied, statutory 
                5
                or otherwise and all representations, statements, negotiations, understandings, and all undertakings either written or oral are
                superseded by the Agreement (save only in respect of liabilities which have accrued in respect of any such prior agreements
                which are so superseded) and the parties hereby acknowledge that no reliance is placed on any such representation made
                but not embodied in these documents.
                18. COMMISSIONS
                The Principal confirms that it is satisfied that all parties with whom it deals with (including advertisers and agencies it deals
                with directly) in the outdoor advertising market are aware of the fee and rebate arrangements which operate within that
                market.
                19. WAIVER
                No delay, neglect, or forbearance on the part of either party in enforcing against the other party any term or condition of the
                Agreement shall either be or be deemed to be a waiver or in any way prejudice any right of that party under the Agreement.
                No right, power or remedy in the Agreement conferred upon or reserved for either party is exclusive or any other right, power
                or remedy available to that party.
                20. CONFIDENTIALITY
                a) Each party will maintain the confidentiality of the other party’s Confidential Information and shall not, without the prior
                written consent of the other, use, disclose, copy or modify the other party’s Confidential Information other than as necessary
                for the performance of its rights and obligations under the Agreement. “Confidential Information” shall mean in relation to the
                other party, information (whether in oral, written or electronic form) belonging or relating to that party, its business affairs or
                activities which is not in the public domain and which:
                i. is marked as confidential or proprietary;
                ii. the receiving party is advised is of a confidential nature; or
                iii. due to its character or nature, a reasonable person in a similar position under similar circumstances would treat as
                confidential.
                b) LifeWise’s Confidential Information will include the Fees payable under the Agreement.
                LifeWise Digital, Inc. agrees to the terms and conditions hereof and by clicking on the “accept” button on the LifeWise Digital
                advertiser portal, appropriately authorized representatives of Advertiser have indicated their acceptance of, and agreement
                to, the terms and conditions contained herein, intending to be legally bound hereby."
                                variant="outlined"
                                multiline
                                maxRows={13}
                                disabled
                            />
                            <br />
                            <StyledCheckbox>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={termsIsChecked}
                                            onChange={() => handleCheckBox()}
                                            name="checkedA"
                                            color="primary"
                                        />
                                    }
                                    label="I accept the Terms and Conditions"
                                />
                            </StyledCheckbox>
                            <br />
                            <div style={{ display: 'flex', justifyContent: 'center' }}>
                                <StyledButton
                                    disabled={isDisabled}
                                    onClick={() => handleSignup(email, password)}
                                    variant="contained"
                                    color="primary"
                                >
                                    {postData.isLoading ? (
                                        <CircularProgress
                                            style={{
                                                height: '20px',
                                                width: '20px',
                                                color: 'white',
                                            }}
                                            color="primary"
                                        />
                                    ) : (
                                        'Sign Up'
                                    )}
                                </StyledButton>
                            </div>
                            <ForgotPasswordLink to="/login">Have a login?</ForgotPasswordLink>
                            {
                                <div
                                    style={{
                                        marginTop: '8px',
                                        marginBottom: '8px',
                                        color: postData?.error ? 'red' : 'green',
                                        fontSize: '13px',
                                    }}
                                >
                                    {postData?.message.length > 1
                                        ? postData?.message.map((item, idx) => (
                                              <div key={idx}>{item}</div>
                                          ))
                                        : postData?.message}
                                </div>
                            }
                        </LoginTextFieldContainer>
                    </Applet>
                    <DownloadLinks
                        onClick={() =>
                            downloadFile(
                                'https://davie-app-bucket.s3.amazonaws.com/photos/LifeWise Advertiser Agreement.pdf',
                                'LifeWise Advertiser Agreement.pdf',
                                'PDF'
                            )
                        }
                    >
                        Download the advertiser terms and conditions
                    </DownloadLinks>
                    {/* <DownloadLinks
            onClick={() =>
              downloadFile(
                'https://davie-app-bucket.s3.amazonaws.com/photos/Advertiser FAQs.pdf',
                'AdvertiserFAQs',
                'PDF'
              )
            }
          >
            Download the advertiser FAQs
          </DownloadLinks> */}
                </AppletContainer>
            </LoginContainer>
        </>
    );
};

export default Signup;
